// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3EIVN","disabled":"FileBtn_disabled__3HY04","warn":"FileBtn_warn__1MPXP","fade":"FileBtn_fade__1ZR7n"};